module.exports = __webpack_public_path__ + "static/img/mtst1.033bae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/mtst1.png
// module id = 3MW4
// module chunks = 59